import React, { Component } from 'react';
import Button from '../Part_Sample/Button';
import Top_Bar from '../Part_Sample/Top_Bar';
import Editbox from '../Part_Sample/Editbox';

import Controller_Cell from './Controller_Cells/Controller_Cell';
import magnifying_glass from '../../Images/Daikin_Images/image/Search.png';

export default class Find_Controller extends Component {
	constructor(props) {
		super(props);
		let controller_list = [];
		this.props.receiver.stored_params.is_from_find_controller_page = true;
		let controller_name = '';

		if (this.props.param.controller_info != null) {
			let controller_info = JSON.parse(JSON.stringify(this.props.param.controller_info));
			// Check model of scanned QR code
			let is_model_allowed = true;
			if (this.props.receiver.app_model == 'H') {
				if (!this.props.receiver.allowed_models.home.includes(controller_info.model)) {
					is_model_allowed = false;
				}
			} else if (this.props.receiver.app_model == 'F') {
				if (!this.props.receiver.allowed_models.office.includes(controller_info.model)) {
					is_model_allowed = false;
				}
			} else {
				is_model_allowed = false;
			}

			if (is_model_allowed) {
				controller_info.is_available = true;
				controller_info.is_selected = true;
				if (controller_info.name != null) controller_name = controller_info.name;

				// Check if controller is already registered. if yes set is_available to false
				let controller_names = window.localStorage.getItem('controller_names') == null ? [] : JSON.parse(window.localStorage.getItem('controller_names'));
				for (let controller_name of controller_names) {
					let ex_controller_info = window.localStorage.getItem(controller_name) == null ? {} : JSON.parse(window.localStorage.getItem(controller_name));

					if (controller_info.mac_addr == ex_controller_info.mac_addr) {
						controller_info.is_available = false;
						break;
					}
				}
				controller_list.push(controller_info);
			} else {
				window.app.showToast(this.props.receiver.getString('invalid_qr'), 3000);
			}
		}

		this.state = {
			controller_name: controller_name,
			controller_list: controller_list,
			is_show_qr_scanner: false,
		}
		this.registration_page = React.createRef();

		// For Beta testing
		/*this.test_unit_controller_info = {};
		if(this.props.receiver.app_model == 'H'){
			// ReiriHome
			this.test_unit_controller_info = {'is_available': true, "ip_addr":"192.168.2.119","mac_addr":"00:01:29:a8:22:35","model":"H01","version":"0.9.21","ssc_connect":true,"ssc_url":"wss://reiri-sin.daikin.com.sg:52010","name":"ReiriHome"}
			this.rcvFoundController(this.test_unit_controller_info);
		}else if(this.props.receiver.app_model == 'F'){
			// Albatross
			this.test_unit_controller_info = {'is_available': true, "ip_addr":"192.168.2.137","mac_addr":"b8:27:eb:1d:5d:26","model":"F01","version":"0.9.21","ssc_connect":true,"ssc_url":"wss://reiri-sin.daikin.com.sg:52010","name":"Albatross"}
			this.rcvFoundController(this.test_unit_controller_info);
		}*/

		// At first, try to find controller
		this.handleFindController();
	}

	handleChangeServerName = (val) => {
		this.setState({
			controller_name: val
		})
	}

	onCreateController = (is_controller_created, new_controller_name) => {
		this.registration_page.current.onCreateController(is_controller_created, new_controller_name);
	}

	handlePrevious = () => {
		delete this.props.receiver.stored_params.is_from_find_controller_page;
		this.props.content_handler(this.props.param.from);
	}

	handleFindController = () => {
		window.app.showLoading();
		this.props.receiver.findController();

		setTimeout(() => {
			window.app.hideLoading();
		}, 5000);
	}

	rcvFoundController = (controller_info) => {
		window.app.hideLoading();

		// Check if controller is already registered. if yes set is_available to false
		let controller_names = window.localStorage.getItem('controller_names') == null ? [] : JSON.parse(window.localStorage.getItem('controller_names'));

		for (let controller_name of controller_names) {
			let ex_controller_info = window.localStorage.getItem(controller_name) == null ? {} : JSON.parse(window.localStorage.getItem(controller_name));
			if (controller_info.mac_addr == ex_controller_info.mac_addr) {
				controller_info.is_available = false;
			}
		}

		// Check if controller with the same mac address already displayed. 
		// If already displayed, do not add to display.
		let controller_list = this.state.controller_list;
		for (let list_item of controller_list) {
			if (list_item.mac_addr == controller_info.mac_addr) {
				return;
			}
		}

		controller_list.push(controller_info);
		this.setState({ controller_list: controller_list });
	}

	activateQRScanner = () => {
		document.getElementById('qr').classList.add('fadeIn');
		delete this.props.receiver.stored_params.is_from_find_controller_page;
		this.props.content_handler('QR_Scanner', { from: 'Find_Controller', original_from: this.props.param.from });
	}

	handleOnSelectController = (index) => {
		let controller_list = this.state.controller_list;
		let controller_name = '';
		for (let i in controller_list) {
			if (i == index) {
				if (controller_list[i].is_selected) {
					controller_list[i].is_selected = false;
					controller_name = '';
				}
				else {
					controller_list[i].is_selected = true;
					if (controller_list[i].name != null && controller_list[i].name != undefined) controller_name = controller_list[i].name;
				}
			} else {
				controller_list[i].is_selected = false;
			}
		}

		this.setState({
			controller_list: controller_list,
			controller_name: controller_name
		})
	}

	isAnyControllerSelected = () => {
		for (let controller_info of this.state.controller_list) {
			if (controller_info.is_selected) {
				return true;
			}
		}
		return false;
	}

	handleRegisterController = () => {
		// Check if controller name is empty
		if (this.state.controller_name == '' || this.state.controller_name == undefined || this.state.controller_name == null) {
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		}

		// Register controller should only save the controller information in the app. 
		// So when the user reopens the app, app can retrieved registered controllers.
		// only setController in the login screen when user selects a controller or during init
		let controller_info = {}

		for (let controller_info of this.state.controller_list) {
			if (controller_info.is_selected) {
				// update and save the list of controller names
				let controller_names = window.localStorage.getItem('controller_names') == null ? [] : JSON.parse(window.localStorage.getItem('controller_names'));
				if (controller_names.includes(this.state.controller_name)) {
					window.app.showToast(this.props.receiver.getString('name_already_exists'), 3000);
					return;
				}
				controller_names.push(this.state.controller_name);
				window.localStorage.setItem('controller_names', JSON.stringify(controller_names));

				// save in local storage controller info with the controller name as key
				controller_info.name = this.state.controller_name;
				/** For Beta Testing**/
				/*if(controller_info.mac_addr == this.test_unit_controller_info.mac_addr){
					controller_info = this.test_unit_controller_info;
				}*/
				/** For Beta Testing**/
				//window.localStorage.setItem(this.state.controller_name, JSON.stringify(controller_info));

				window.localStorage.setItem(this.state.controller_name, JSON.stringify(controller_info));

				// Save the controller name as the active controller
				window.localStorage.setItem('active_controller_name', this.state.controller_name);

				// Kaiwei 20210309 Comm_Module revamp
				delete this.props.receiver.stored_params.is_from_find_controller_page;
				this.props.content_handler('Login_Page');
				return;
			}
		}

		// If no controller selected
		window.app.showToast(this.props.receiver.getString('select_controller'), 3000);
	}

	render() {
		let is_any_controller_selected = this.isAnyControllerSelected();

		let is_landscape = this.props.width > this.props.height;

		return (
			<div>
				<Top_Bar
					width={this.props.width}
					title={this.props.receiver.getString('register_controller')}
					left_button_type={'back'}
					handleLeftButton={this.handlePrevious}
					right_button_type={'qr'}
					handleRightButton={this.activateQRScanner}
				/>
				<div style={{ width: this.props.width - 40, textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', }}>
					<Editbox read_only={!is_any_controller_selected} value={this.state.controller_name} id={'controller_name'} style={{ marginBottom: 10 }} placeholder={this.props.receiver.getString('controller_name')} inputType='text' onChange={(event) => this.handleChangeServerName(event.target.value)} />
				</div>
				<div style={{ marginTop: 20, marginLeft: 20 }}>
					<div style={{ width: this.props.width - 80, display: 'inline-block', verticalAlign: 'top', paddingTop: 10 }}>
						<span className='normal' style={{ fontSize: 20, color: this.props.colours.normal_font }}>{this.props.receiver.getString('select_controller')}</span>
					</div>
					<img src={magnifying_glass} style={{ cursor: 'pointer', width: 40 }} onClick={this.handleFindController} />
				</div>

				<div style={{ display: this.state.controller_list.length > 0 ? 'block' : 'none', background: 'white' }}>
					<div style={{ height: is_landscape ? 'auto' : this.props.height - 303, overflow: 'auto', marginLeft: 10 }}>
						{this.state.controller_list.map((controller_info, index) => {
							return (
								<Controller_Cell
									index={index}
									controller_info={controller_info}
									handleOnClick={(index) => this.handleOnSelectController(index)}
									receiver={this.props.receiver}
								/>
							)
						})}
					</div>
				</div>
				<div style={{ width: this.props.width * 0.9, display: is_any_controller_selected && this.state.controller_name != '' ? 'block' : 'none' }}>
					<Button id="reg_controller" style={{ color: this.props.colours.button_font, width: '100%', padding: 20, borderRadius: 20, margin: 0, marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }} bgColor={this.props.colours.button_bg} onClick={this.handleRegisterController}>{this.props.receiver.getString('save')}</Button>
				</div>
			</div>
		)
	}
}


